// | Transport type for Tuple.
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $T2 = (_1, _2) => ({tag: "T2", _1, _2});
const T2 = value0 => value1 => $T2(value0, value1);
const toTuple = v => Data$dTuple.$Tuple(v._1, v._2);
const proj2 = v => v._2;
const proj1 = v => v._1;
const genericT2 = {to: x => $T2(x._1, x._2), from: x => Data$dGeneric$dRep.$Product(x._1, x._2)};
const showT2 = dictShow => dictShow1 => (
  {
    show: (() => {
      const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsProduct({genericShowArgs: v => [dictShow.show(v)]})({
        genericShowArgs: v => [dictShow1.show(v)]
      }))({reflectSymbol: () => "T2"});
      return x => $0["genericShow'"](Data$dGeneric$dRep.$Product(x._1, x._2));
    })()
  }
);
const udecodeT2 = dictDecode => dictDecode1 => (
  {
    unsafeDecode: (() => {
      const $0 = Unscramble$dGeneric.genericDecodeArgs1(Unscramble$dGeneric.genericDecodeManyArgsProd({
        argsDecoder: Data$dTuple.$Tuple(1, offset => array => dictDecode.unsafeDecode(array[offset]))
      })({argsDecoder: Data$dTuple.$Tuple(1, offset => array => dictDecode1.unsafeDecode(array[offset]))}));
      return x => {
        const $1 = $0.genericDecodeArgs(x);
        return $T2($1._1, $1._2);
      };
    })()
  }
);
const fromTuple = v => $T2(v._1, v._2);
const eqT2 = dictEq => dictEq1 => ({eq: x => y => dictEq.eq(x._1)(y._1) && dictEq1.eq(x._2)(y._2)});
const encodeT2 = dictGenericEncodeArgs => dictGenericEncodeArgs1 => (
  {
    encode: Foreign$dEncoding.defaultEncode(genericT2)(Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "T2"})(Foreign$dGeneric$dClass.genericEncodeArgsProduct(dictGenericEncodeArgs)(dictGenericEncodeArgs1)))
  }
);
const decodeT2 = dictGenericDecodeArgs => dictGenericDecodeArgs1 => (
  {
    decode: Foreign$dEncoding.defaultDecode(genericT2)(Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "T2"})(Foreign$dGeneric$dClass.genericDecodeArgsProduct(dictGenericDecodeArgs)(dictGenericDecodeArgs1))(Foreign$dGeneric$dClass.genericCountArgsProduct(Foreign$dGeneric$dClass.genericCountArgsArgument)(Foreign$dGeneric$dClass.genericCountArgsArgument)))
  }
);
export {$T2, T2, decodeT2, encodeT2, eqT2, fromTuple, genericT2, proj1, proj2, showT2, toTuple, udecodeT2};
